import BaseApi from "Services/http/BaseApi";
import { headers } from "Services/http/ApiSettings";

class Profile extends BaseApi {
  constructor() {
    super({ suffix: "" });
  }

  getProfileInfo(params) {
    return this.httpService.get("Acounts/profile-user", { headers, params });
  }

  putProfileEdit(data) {
    return this.httpService.put("Acounts/change-displayname-avatar ", data, {
      headers,
    });
  }

  postProfileContact(data) {
    return this.httpService.post(
      "Accounts/send-code-update-phone-email ",
      data,
      { headers }
    );
  }

  putChangeAcounts(data) {
    return this.httpService.put("Acounts/change-two-factor-user ", data, {
      headers,
    });
  }

  putChangePassword(data) {
    return this.httpService.put("Acounts/change-password-user ", data, {
      headers,
    });
  }


  putChangeAcount(data) {
    return this.httpService.put("Accounts/verify-update-phone-email ", data, {
      headers,
    });
  }
}

const UserProfileService = new Profile();
export default UserProfileService;
